module.exports = __webpack_public_path__ + "static/media/store_white_24dp.0e0f3505.svg";